import { faTimes, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Checkbox, Tooltip, Divider } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Portal from "./HeaderPortal";
import { Props } from "./interfaces";
import {
  Container,
  DeleteButton,
  Search,
  SearchContainer,
  InputBase,
  Icon,
  // TitleContainer,
  Toolbar,
  ToolbarInnerContainer,
} from "./styles";
import ChartsContainer from "../Charts/ChartsContainer/ChartsContainer";
import QuickfiltersContainer from "../Quickfilters/QuickfiltersContainer/QuickfiltersContainer";

const TableHeader = ({
  buttonToRender,
  tableTitle,
  searchOptions,
  handleChangeSearchOptions,
  quickFilters,
  charts,
  handleNotifyOnChartResize,
  getSearchQuery,
  titleElement,
  hideSearch = false,
}: Props) => {
  // const [chartsOpen, setChartsOpen] = useState<boolean>(true);
  // const handleCloseCharts = useCallback(() => {
  //   setChartsOpen(false);
  // }, []);

  const { t } = useTranslation();

  return (
    <Container id="tableHeader">
      <Portal
        title={tableTitle}
        buttonToRender={titleElement}
      />

      <ChartsContainer
        charts={charts}
        handleNotifyOnChartResize={handleNotifyOnChartResize}
      />

      <Toolbar container>
        <ToolbarInnerContainer sx={{ flexGrow: 1, alignItems: "center" }}>
          {buttonToRender && (
            <>
              <Grid style={{ alignSelf: "center" }}>{buttonToRender}</Grid>
              <Divider
                flexItem
                orientation={"vertical"}
                variant={"middle"}
              />
            </>
          )}
          {quickFilters && <QuickfiltersContainer>{quickFilters}</QuickfiltersContainer>}
        </ToolbarInnerContainer>
        <ToolbarInnerContainer>
          {quickFilters && !hideSearch && (
            <Divider
              flexItem
              orientation={"vertical"}
              variant={"middle"}
            />
          )}
          {!hideSearch && (
            <SearchContainer>
              <Search>
                <InputBase
                  startAdornment={
                    <Tooltip
                      title={searchOptions?.query ? "Exact Match" : ""}
                      placement="top"
                    >
                      <Checkbox
                        disabled={!searchOptions?.query}
                        checked={searchOptions?.exactMatch}
                        onChange={(e) => handleChangeSearchOptions("change", "exactMatch", e.target.checked)}
                      />
                    </Tooltip>
                  }
                  endAdornment={
                    searchOptions?.query ? (
                      <DeleteButton
                        onMouseDown={(e) => {
                          e.preventDefault();
                          !!getSearchQuery && getSearchQuery("");
                          handleChangeSearchOptions("reset");
                        }}
                      >
                        <Icon>
                          <FontAwesomeIcon icon={faTimes} />
                        </Icon>
                      </DeleteButton>
                    ) : (
                      <Icon>
                        <FontAwesomeIcon icon={faSearch} />
                      </Icon>
                    )
                  }
                  value={searchOptions?.query}
                  onChange={(e) => {
                    !!getSearchQuery && getSearchQuery(e.target.value);

                    handleChangeSearchOptions("change", "query", e.target.value);
                  }}
                  placeholder={`${t("common_words.search")}...`}
                />
              </Search>
            </SearchContainer>
          )}
        </ToolbarInnerContainer>

        {/* 
        <FormControlLabel // todo: hidden for now, to be used in future
          control={
            <Checkbox
              checked={searchOptions.deletedItems}
              onChange={(e) => handleChangeSearchOptions("change", "deletedItems", e.target.checked)}
            />
          }
          label={"Deleted items"}
        />
        */}
      </Toolbar>
    </Container>
  );
};

export default TableHeader;
